"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _CarouselCard = _interopRequireDefault(require("../CarouselCard"));

var _ProductCategoryCard = _interopRequireDefault(require("../ProductCategoryCard"));

var _GalleryCard = _interopRequireDefault(require("../GalleryCard"));

var _VerticalContentCard = _interopRequireDefault(require("../VerticalContentCard"));

var _ShoppingProductCard = _interopRequireDefault(require("../ShoppingProductCard"));

var _HotelCard = _interopRequireDefault(require("../HotelCard"));

var _HotelsCrossSellCard = _interopRequireDefault(require("../HotelsCrossSellCard"));

var _constant = require("./constant");

var _card = _interopRequireDefault(require("./card.proptypes"));

var chooseTemplate = function chooseTemplate(props) {
  var _ref;

  return _ref = {}, (0, _defineProperty2.default)(_ref, _constant.TEMPLATE_TYPE.PRODUCT_CARD, /*#__PURE__*/_react.default.createElement(_CarouselCard.default, (0, _extends2.default)({
    productType: props.data.productType
  }, props))), (0, _defineProperty2.default)(_ref, _constant.TEMPLATE_TYPE.PRODUCT_CATEGORY, /*#__PURE__*/_react.default.createElement(_ProductCategoryCard.default, (0, _extends2.default)({
    productType: props.data.productType
  }, props))), (0, _defineProperty2.default)(_ref, _constant.TEMPLATE_TYPE.PRODUCT_GALLERY, /*#__PURE__*/_react.default.createElement(_GalleryCard.default, (0, _extends2.default)({
    productType: props.data.productType
  }, props))), (0, _defineProperty2.default)(_ref, _constant.TEMPLATE_TYPE.VERTICAL_CONTENT_CARD, /*#__PURE__*/_react.default.createElement(_VerticalContentCard.default, (0, _extends2.default)({
    productType: props.data.productType
  }, props))), (0, _defineProperty2.default)(_ref, _constant.TEMPLATE_TYPE.HOTEL_CARD, /*#__PURE__*/_react.default.createElement(_HotelCard.default, (0, _extends2.default)({
    productType: props.data.productType
  }, props, props.data))), (0, _defineProperty2.default)(_ref, _constant.TEMPLATE_TYPE.HOTELS_CROSS_SELL_CARD, /*#__PURE__*/_react.default.createElement(_HotelsCrossSellCard.default, (0, _extends2.default)({
    productType: props.data.productType
  }, props, props.data))), (0, _defineProperty2.default)(_ref, _constant.TEMPLATE_TYPE.SHOPPING_PRODUCT_CARD, /*#__PURE__*/_react.default.createElement(_ShoppingProductCard.default, (0, _extends2.default)({
    productType: props.data.productType
  }, props, props.data))), _ref;
};

var Card = function Card(props) {
  var templateType = props.templateType;
  return chooseTemplate(props)[templateType];
};

Card.propTypes = _card.default.PropTypes;
Card.defaultProps = _card.default.DefaultProps;
var _default = Card;
exports.default = _default;